<template>
  <td class="text-xs-left ph-no-capture" data-td="client">
    <template v-if="pageLoading"> Loading </template>

    <template v-else>
      <v-layout align-center class="data-cell__name">
        <sx-flex :is-centered="true" class="data-cell__user">
          <sx-icon name="person" :size="16" color="currentcolor" />
        </sx-flex>

        <sx-flex :is-column="true">
          <a
            class="client-name mr-1"
            @click="changeCurrentCompanyFromDataCell($event)"
            :href="'/admin-dashboard/' + this.hash"
          >
            <sx-tiny>{{ this.client }}</sx-tiny>
          </a>
        </sx-flex>

        <!-- TODO @chris Hiding this until we have a better UX within all tasks. -->
        <!-- <sx-flex x-align="right">
          <v-chip
            v-if="needsInactiveChip()"
            color="error"
            small
            class="white--text caption"
            >No client activity in 4 weeks
          </v-chip>
        </sx-flex> -->
      </v-layout>
    </template>
  </td>
</template>
<script>
import moment from 'moment';
import SxFlex from '@/components/sx/SxFlex';
import SxIcon from '@/components/sx/SxIcon';
import SxTiny from '@/components/sx/SxTiny';

export default {
  components: {
    SxFlex,
    SxIcon,
    SxTiny,
  },

  props: {
    changeCurrentCompany: {
      type: Function,
    },

    client: {
      type: String,
    },

    companyId: {
      type: Number,
    },

    hash: {
      type: String,
    },

    isCompleted: {
      type: Boolean,
    },

    isLocked: {
      type: Boolean,
    },

    pageLoading: {
      type: Boolean,
    },

    updatedAtByClient: {
      type: String,
    },
  },

  methods: {
    async changeCurrentCompanyFromDataCell(event) {
      return this.changeCurrentCompany(
        event,
        this.companyId,
        `/admin-dashboard/${this.hash}`,
      );
    },

    needsInactiveChip() {
      if (this.isCompleted) return false;
      if (this.isLocked) return false;
      if (!this.updatedAtByClient) return false;

      return moment(this.updatedAtByClient) < moment().subtract(4, 'weeks');
    },
  },
};
</script>

<style lang="css">
/* styles taken from /page/accountant/Overview.vue */
.data-cell__name {
  align-items: center;
  display: flex;
  gap: 6px;
  padding: 2px 0;

  text-align: left !important;
}

.data-cell__user {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  min-width: 24px;
  max-width: 24px;
  width: 24px;

  background-color: var(--blue-100);
  border-radius: 100%;
  color: var(--blue-600);
}
</style>
